(function ($, App, Utils, Components, Pages) {
    'use strict';

    const logger = new Logger('Purchaseables');

    Pages.create('Purchaseables', {

        Cart: {
            updateTimer: undefined
        },

        Selectors: {
            catalog: '.prizes-catalog',
            items: '.purchaseable',
            showCommands: '.purchaseable .show-commands',
            activeControls: '.prizes-catalog.ready .purchaseable.ready .cart-ctrl-amount',
            itemCount: '.purchaseable .cart-count',
            itemTotal: '.purchaseable .itm-tot',
            spinner: '#prize-spn-template',
            cartSummary: '#nav-crt',
            cartCount: '#nav-crt .crt-cnt-tot',
            cartTotal: '#nav-crt .crt-amn-tot',
            cartDiscountedTotal: '#nav-crt .crt-amn-dis',
            orderDetail: '#order-detail',
            thankyouPageContainer: '.thankyou-page'
        },

        setReady: ($prod) => {
            $prod.addClass('ready');
            $(Pages.Purchaseables.Selectors.catalog).addClass('ready');
        },

        loadCart: (orderId) => {
            let id = orderId ? '?orderId=' + orderId : '';
            axios({
                method: 'get',
                url: '/action/cart/get' + id,
            }).then(function (r) {
                Pages.Purchaseables.applyCart(r.data);
                Pages.Purchaseables.setReady($(Pages.Purchaseables.Selectors.items));
            }).catch(function (r) {
                logger.error("Error loading cart", r);
            });
        },

        applyCart: (cart) => {
            $(Pages.Purchaseables.Selectors.itemTotal).text("€ 0.00").data('total', 0);
            cart.entries.forEach((e) => {
                let $prodCount = Pages.Purchaseables.selectProduct(e.productsGroup, e.productId, Pages.Purchaseables.Selectors.itemCount),
                    $prodTot = Pages.Purchaseables.selectProduct(e.productsGroup, e.productId, Pages.Purchaseables.Selectors.itemTotal),
                    amount = Math.max(e.count, 0),
                    total = e.price * amount;
                $prodCount.data('amount', amount);
                $prodCount.text(amount);
                $prodTot.data('total', total);
                $prodTot.text("€ " + Utils.currencyFormatter(total));
            });
            let $discount = $(Pages.Purchaseables.Selectors.cartDiscountedTotal),
                discountValue = $discount.data('discount') || 0.95;
            $(Pages.Purchaseables.Selectors.cartCount).text(cart.entries.length);
            $(Pages.Purchaseables.Selectors.cartTotal).text('€' + Utils.currencyFormatter(cart.entriesTotal));
            $(Pages.Purchaseables.Selectors.cartDiscountedTotal).text('€' + Utils.currencyFormatter(cart.entriesTotal * discountValue));
            logger.info("Updated cart: ", cart);
        },

        bindEvents: () => {
            $(Pages.Purchaseables.Selectors.showCommands).on('click', (e) => {
                $(e.target).addClass('active')
            });

            $(document).on('click', Pages.Purchaseables.Selectors.activeControls, (e) => {
                let $this = $(e.target),
                    amount = Number($this.data('amount')),
                    $item = $this.closest('.purchaseable'),
                    prodId = $item.data('product'),
                    catalogId = $item.data('catalog'),
                    price = $item.data('price');
                console.log("ciao", $item);
                Pages.Purchaseables.updateitemCount(catalogId, prodId, amount, price);
            });
        },

        bindNoCartEvents: () => {
            logger.info("No cart events: Not implemented");
        },

        updateitemCount: (catalogId, productId, amount, price) => {
            amount = Pages.Purchaseables.setCount(catalogId, productId, amount);
            clearTimeout(Pages.Purchaseables.Cart.updateTimer);
            Pages.Purchaseables.Cart.updateTimer = setTimeout(() => Pages.Purchaseables.updateCart(catalogId, productId, amount, price), 500);
        },

        setCount: (catalogId, productId, amount) => {
            let $prodCount = Pages.Purchaseables.selectProduct(catalogId, productId, Pages.Purchaseables.Selectors.itemCount);
            amount = Math.max(Number($prodCount.data('amount')) + amount, 0);
            $prodCount.data('amount', amount);
            $prodCount.text(amount);
            return amount;
        },

        selectProduct: (catalogId, productId, find) => {
            return $('#' + catalogId + '-' + productId + (find || ''));
        },

        updateCart: (catalogId, productId, quantity, price) => {
            let $prod = Pages.Purchaseables.selectProduct(catalogId, productId);
            Pages.Purchaseables.updateEntry($prod);
            axios.post('/action/cart/add', {
                catalogId: catalogId,
                productId: productId,
                quantity: quantity,
                price: price
            }).then(function (r) {
                Pages.Purchaseables.applyCart(r.data);
                Pages.Purchaseables.setReady($prod);
            }).catch(function (r) {
                logger.error("Error updating cart", r);
            });
        },

        updateEntry: (prod) => {
            $(Pages.Purchaseables.Selectors.catalog).removeClass('ready');
            prod.removeClass('ready');
            $(Pages.Purchaseables.Selectors.spinner).prependTo(prod.find('.spinner'));
        },
        
        trackCheckout: () => {
        	$( document ).ready(() => {
        		var $thankyouPageContainer = $(Pages.Purchaseables.Selectors.thankyouPageContainer);
            	if($thankyouPageContainer.length > 0 && $thankyouPageContainer.data('checkout-completed')) {
            		App.Utils.Gtm.checkoutEvent();
            	}
        	});
        },

        init: () => {
            /*
            *   cart summary exists only if a cart has been generated/loaded, thus a user has logged in
            *   -> load cart info
            *   -> bind cart events
            */
            if ($(Pages.Purchaseables.Selectors.cartSummary).length) {
                logger.info("Cart is initialized");

                if ($(Pages.Purchaseables.Selectors.orderDetail).length) {
                    Pages.Purchaseables.loadCart($(Pages.Purchaseables.Selectors.orderDetail).val());
                } else {
                    Pages.Purchaseables.loadCart();
                    Pages.Purchaseables.bindEvents();
                    logger.info('Purchases enabled');
                }
            }
            else {
                Pages.Purchaseables.bindNoCartEvents();
            }
            Pages.Purchaseables.trackCheckout();
        }

    });

})(jQuery,
    window.App,
    window.App.Utils,
    window.App.Components,
    window.App.Pages
);
